exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-fade-left-enter-active{transition:all .35s ease-in-out;transition-delay:.1s}.slide-fade-left-leave-active{position:absolute;transition:all .45s ease-in-out}.slide-fade-left-enter{transform:translate(-50%);opacity:0}.slide-fade-left-enter-to{transform:translate(0);opacity:1}.slide-fade-left-leave-to{transform:translate(50%);opacity:0}", ""]);

// exports
